export default defineNuxtPlugin(() => {
    const {
        public: { environment },
    } = useRuntimeConfig();

    return {
        provide: {
            environment: () => {
                const env = environment.toLowerCase();

                if (env === "development") {
                    return "development";
                } else if (env === "staging") {
                    return "staging";
                }

                return "production";
            },
        },
    };
});
